import React from 'react';
import ClassesListPage from './ClassesListPage';

const ActiveClasses: React.FC = () => {
  return <ClassesListPage defaultFilter="active" title="Active Classes" />;
};

export default ActiveClasses; 